import ApiService from "services/ApiService";

const badRequestCode = 400;

export const ResellerService = {
    getResellerSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/Account/Reseller/Settings`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                },
            );
        });
    },
    updateResellerSettings(
        websiteLogoFile,
        reportLogoFile,
        sidebarColour,
        sidebarTextColour,
        sidebarActiveMenuColour,
    ) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("websiteLogo", websiteLogoFile);
        formData.append("reportLogo", reportLogoFile);
        formData.append("sidebarColour", sidebarColour);
        formData.append("sidebarTextColour", sidebarTextColour);
        formData.append("sidebarActiveMenuColour", sidebarActiveMenuColour);

        return new Promise((resolve, reject) => {
            ApiService.put(`/Account/Reseller/Settings`, formData, config).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    if (error.response && error.response.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject("Could not save reseller settings. Please try again later.");
                    }
                },
            );
        });
    },
    resetTheme() {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/Account/Reseller/Settings`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                },
            );
        });
    },
};
